import { Navigate, Outlet } from "react-router-dom";

const ProtectedLayout = () => {
  const token = localStorage.getItem("agent_access_token");

  if (!token) return <Navigate to={"/auth/otp"} replace />;

  return <Outlet />;
};

export default ProtectedLayout;
